'use strict';
export class CurationSettings {
  public static TAB_ABERRATION_LABEL: string = 'Aberrations';
  public static TAB_PATHWAY_LABEL: string = 'Pathways';
  public static TAB_WORKLIST_LABEL: string = 'Worklist';
  public static TAB_CLINICALTRIAL_LABEL: string = 'Trials';
  public static APPROVED_ROOT: string = 'lastApproved';
  public static IN_REVIEW_ROOT: string = 'inReview';
  public static CURATION_PATHWAY: string = 'pathway';
  public static CURATION_PATHWAY_BPMN: string = 'pathwaybpmn';
  public static CURATION_ABERRATION: string = 'aberration';
  public static CURATION_TREATMENTPROTOCOL: string = 'treatmentprotocol';
  public static CURATION_SUMMARY: string = 'summary';
  public static CURATION_REGIMEN: string = 'regimen';
  public static CURATION_PLACEMENT: string = 'placement';
  public static CURATION_TREATMENTPLAN: string = 'treatmentplan';
  public static CURATION_CLINICAL_TRIAL: string = 'clinicaltrial';
  public static CURATION_WORKLIST: string = 'worklist';
  public static CURATION_CLINICALTRIAL: string = 'clinical_trial';
  public static CURATION_KB: string = 'curationKB';
  public static CURATION_GRANTED_KB: string = 'grantedKb';
  public static CURATION_EDITOR_WITH_REPORT: string [] = ['pathway', 'summary'];
  public static CURATION_ORGANIZATION: string = 'organization';

  public static CURATION_STATUS_DRAFT: string = 'draft';
  public static CURATION_STATUS_APPROVED: string = 'approved';
  public static CURATION_STATUS_REJECTED: string = 'rejected';
  public static CURATION_STATUS_ARCHIVED: string = 'archived';
  public static CURATION_STATUS_WAITING_FOR_ARCHIVE: string = 'waitforarchive';
  public static CURATION_STATUS_APPROVED_SUBMITTED: string = 'approvedsubmitted';
  public static CURATION_STATUS_ARCHIVED_SUBMITTED: string = 'archivedsubmitted';
  public static CURATION_STATUS_WAITING_FOR_APPROVAL: string = 'waitforapproval';
  public static CURATION_STATUS_INREVIEW: string = 'inreview';
  public static CURATION_STATUS_PUBLISHED: string = 'published';
  public static CURATION_STATUS_PUBLISHED_SUBMITTED: string = 'publishedsubmitted';
  public static CURATION_STATUS_REVIEW_FEEDBACK_RECEIVED: string = "reviewFeedbackReceived";
  public static CURATION_VIRTUAL_STATUS_DISCARD: string = "discard";
  public static CURATION_STATUS_PREVIOUS_STATUS: string = "previousStatus";

  public static CURATOR_ROLE: string = 'CURATOR';
  public static TABLE_TAG_DELETED: string = 'deleted';
  public static TABLE_TAG_DEL_REV_ID: string = 'itemDeletedRevisionId';
  public static APPROVAL_DOC_NAME: string = 'ApprovalDocument.';

  public static lastCurationTab: string;
  public static lastCurationPage: number = -1;
  public static lastSearch: string;
  public static PATHWAYBPMN_NAME: string = 'pathwayBpmnName';
  public static PLACEMENT_NAME = 'placementName';
  public static CURATION_MDA_WORKLIST: string = 'mda_worklist';
  public static CONTENT_PATHWAYBPMN_NAME = 'content.pathwayBpmnName';
  public static CONTENT_PLACEMENT_NAME = 'content.placementName';
  public static CONTENT_DISCIPLINE_DISPLAY = 'content.discipline.display';
  public static CONTENT_DISCIPLINE_CODE ='content.discipline.code';
  public static CONTENT_DISEASE_CODE = 'content.disease.code';

  public static CREATE_TAG_USER_CREATED = 'userCreated';
  public static CREATE_TAG_MANUALLY_CREATED = 'manuallyCreated';
  public static NODE_UPDATE_FIELD_CLINICAL_TRIAL = 'clinicalTrial';
  public static NODE_UPDATE_FIELD_PLACEMENT_NAME = 'placementName';
  public static NODE_UPDATE_FIELD_NODES: string = 'nodes';

  public static CURATION_NODE_NOT_DEFINED = '---';
  public static CURATION_NODE_IS_DELETED = 'Selected node does not exist';

  public static MULTIPLE_KB = 'multipleKb';
  public static GRANTED_ACTIONS_TABLE = 'grantedActionsTable';
  public static GRANTED_ACTIONS_CLONE_ACTION = 'clone';
  public static GRANTED_ACTIONS_RUN_PREVIEW_ACTION = 'runPreview';
  public static CURATION_CLONE_WARNING = 'Note, cloning a type created by another organization, disconnects the type from any updates performed by the originator, would you like to continue?';
  public static CURATION_CLONE_CLEAN_FIELDS = 'otherOrgCleanFields';
}

export enum CurationTypes {
    pathwaybpmn = 'Pathway BPMN',
    treatmentplan = 'Treatment Plan',
    regimen = 'Regimen',
    pathway = 'Pathway',
    clinicaltrial = 'Clinical Trial',
    summary = 'Committee Review',
    treatmentprotocol = 'Treatment Protocol',
    placement = 'Trial Placement',
    aberration = 'Aberration'
}

export enum CurationNodeSelectionSource {
   explorerView = 'Explorer View',
   modelerView = 'Modeler View'
}

export enum CurationPanels {
  rightPanel = 'rightPanel',
  explorerViewPanel = 'explorerView',
  treeViewIconContainer = 'treeViewIconContainer'
}
